import { Directive, TemplateRef, inject } from '@angular/core';

@Directive({
  selector: '[zefSidenavButtonPrimary]',
  standalone: false,
})
export class SidenavButtonPrimary {
  readonly tr = inject<TemplateRef<any>>(TemplateRef);
}
